import Vue from 'vue'
import VueRouter from 'vue-router'
import HeaderView from '../components/HeaderView.vue'
import NavMenuView from '../components/NavMenuView.vue'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import HoldManageView from '../views/hold/HoldManageView.vue'
import DeviceManageView from '../views/device/DeviceManageView.vue'
import PatrolCardManage from '../views/patrol_card/PatrolCardManage.vue'
import PatrolRoadManage from '../views/patrol_card/PatrolRoadManage.vue'
import PatrolRoadDetail from '../views/patrol_card/PatrolRoadDetail.vue'
import PatrolDataManage from '../views/patrol_card/PatrolDataManage.vue'
import StaffManage from '../views/staff/StaffManageView.vue'
import PatrolRecords from '../views/patrol_data/PatrolRecordsView.vue'
import PatrolTotalByPointer from '../views/patrol_data/PatrolTotalByPointerView.vue'
import PatrolTotalByDevice from '../views/patrol_data/PatrolTotalByDeviceView.vue'
import PatrolTotalByUser from '../views/patrol_data/PatrolTotalByUserView.vue'
import PatrolRoadState from '../views/patrol_card/PatrolRoadStateView.vue'
import PatrolTasks from '../views/patrol_card/PatrolTasksManageView.vue'
import OptLogs from '../views/sys/OptLogsView.vue'
import LoginLogs from '../views/sys/LoginLogsView.vue'
import Setting from '../views/sys/SettingView.vue'
import RoadInfoManage from '../views/road_info/RoadInfoManageView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    components: {
      default: LoginView
    },
    meta: { title: "登录 - 天下行巡更系统" }
  },
  {
    path: '/home/dashboard',
    name: 'home',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: HomeView
    },
    meta: { title: "首页 - 天下行巡更系统" }
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: LoginView
    },
    meta: { title: "Login - 天下行巡更系统" }
  },
  {
    path: '/hold/manage',
    name: 'hold_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: HoldManageView
    },
    meta: { title: "用户管理 - 天下行巡更系统" }
  },
  {
    path: '/device/manage',
    name: 'device_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: DeviceManageView
    },
    meta: { title: "设备管理 - 天下行巡更系统" }
  },
  {
    path: '/patrol/card_manage',
    name: 'patrolcard_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolCardManage
    },
    meta: { title: "巡检点管理 - 天下行巡更系统" }
  },
  {
    path: '/patrol/road_manage',
    name: 'patrolroad_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolRoadManage
    },
    meta: { title: "巡检路线 - 天下行巡更系统" }
  },
  {
    path: '/patrol/road_detail',
    name: 'patrolroad_detail',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolRoadDetail
    },
    meta: { title: "新增路线 - 巡检线路" }
  },
  {
    path: '/patrol/data_manage',
    name: 'patroldata_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolDataManage
    },
    meta: { title: "数据查询 - 天下行巡更系统" }
  },
  {
    path: '/staff/manage',
    name: 'staff_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: StaffManage
    },
    meta: { title: "员工管理 - 天下行巡更系统" }
  },
  {
    path: '/patrol/records',
    name: 'patrol_data',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolRecords
    },
    meta: { title: "巡检记录 - 天下行巡更系统" }
  },//PatrolTotalByDevice
  {
    path: '/patrol/total_by_pointer',
    name: 'patrol_total_pointer',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolTotalByPointer
    },
    meta: { title: "巡检统计（按巡检点） - 天下行巡更系统" }
  },
  {
    path: '/patrol/total_by_device',
    name: 'patrol_total_device',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolTotalByDevice
    },
    meta: { title: "巡检统计（按设备） - 天下行巡更系统" }
  },
  {
    path: '/patrol/total_by_user',
    name: 'patrol_total_user',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolTotalByUser
    },
    meta: { title: "巡检统计（按人员） - 天下行巡更系统" }
  },
  {
    path: '/patrol_road/state',
    name: 'patrol_total_user',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolRoadState
    },
    meta: { title: "巡检线路状态 - 天下行巡更系统" }
  },
  {
    path: '/sys/opt_logs',
    name: 'sys_opt_logs',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: OptLogs
    },
    meta: { title: "操作日志 - 天下行巡更系统" }
  },
  {
    path: '/sys/login_logs',
    name: 'sys_login_logs',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: LoginLogs
    },
    meta: { title: "登录日志 - 天下行巡更系统" }
  },
  {
    path: '/patrol/tasks',
    name: 'patrol_tasks',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: PatrolTasks
    },
    meta: { title: "巡检任务 - 天下行巡更系统" }
  },
  {
    path: '/sys/setting',
    name: 'sys_setting',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: Setting
    },
    meta: { title: "个人设置 - 天下行巡更系统" }
  },
  {
    path: '/road/manage',
    name: 'road_manage',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: RoadInfoManage
    },
    meta: { title: "线路管理 - 天下行巡更系统" }
  },
  {
    path: '/about2',
    name: 'about',
    components: {
      header: HeaderView,
      aside: NavMenuView,
      default: AboutView
    },
    meta: { title: "About - 天下行巡更系统" }
  }
]

const router = new VueRouter({
  routes
})

export default router
